import {
  type Configuration,
  type CreateRestoreTemplateRequest,
  type UpdateRestoreTemplateRequest,
  type RestoreTemplateResourceType,
  RestoreTemplatesApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/restore-templates';

export const restoreTemplates = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const restoreTemplatesApi = new RestoreTemplatesApi(config);

  return {
    useList: (resourceType?: RestoreTemplateResourceType) =>
      httpClient.execute(
        restoreTemplatesApi.listRestoreTemplates.bind(restoreTemplatesApi),
        baseUrl,
        '',
        currentProjectId,
        resourceType
      ),
    useGet: (restoreTemplateId: string | null) =>
      httpClient.execute(
        restoreTemplatesApi.getRestoreTemplate.bind(restoreTemplatesApi),
        restoreTemplateId ? baseUrl : null,
        restoreTemplateId ?? '',
        currentProjectId,
        restoreTemplateId ?? ''
      ),
    create: (body: CreateRestoreTemplateRequest) =>
      restoreTemplatesApi.createRestoreTemplate(currentProjectId, body),
    update: (restoreTemplateId: string, body: UpdateRestoreTemplateRequest) =>
      restoreTemplatesApi.updateRestoreTemplate(
        currentProjectId,
        restoreTemplateId,
        body
      ),
    delete: (restoreTemplateId: string) =>
      restoreTemplatesApi.deleteRestoreTemplate(
        currentProjectId,
        restoreTemplateId
      ),
    bulkAttach: (restoreTemplateId: string, resourceIds: string[]) =>
      restoreTemplatesApi.bulkSetRestoreTemplate(
        currentProjectId,
        restoreTemplateId,
        { resourceIds }
      ),
  };
};
